<template>
    <div>
        <div class="d-flex justify-content-end align-item-center mb-4">
            <b-button variant="outline-primary"  @click="newApplication"> <i class="ri-add-fill mr-2"></i>{{$t('new') + ' ' + $t('application')}}</b-button>
        </div>
        <div v-if="this.user && this.user.length > 0">
            <div  v-for="(user,i) in this.user" :key="i" class="mb-2">
                <b-button v-b-toggle="`collapse-${i}`" variant="outline-primary" class="w-100">
                    <span v-if="user.payment_status==='E'">
                          {{ $t('application') }} #{{ i + 1 }}
                    </span>
                    <span v-else>
                        {{$t('new')}} {{$t('application')}} #{{ i + 1 }}
                    </span>
                </b-button>
                <b-collapse :id="`collapse-${i}`" :visible="user.payment_status==='H'" class="mt-2">
                    <b-card>
                        <b-alert variant="success" :show="user.payment_status==='E'" v-if="user.payment_status==='E'">
                            <h4 class="alert-heading">Sayın {{user.name?.toLocaleUpperCase('tr-TR')}} {{user.surname?.toLocaleUpperCase('tr-TR')}}</h4>
                            <span>
                           </span>  {{toLocaleDateTime(user?.payment_date)}} Tarihinde Başvurunuz başarıyla tamamlanmıştır.
                        </b-alert>
                        <ValidationObserver :ref="`applicationForm-${i}`" v-slot="{ invalid, pristine }">
                            <b-row>
                                <b-col sm="12" md="6" lg="6">
                                    <ValidationProvider name="university_id"  rules="required" v-slot="{ valid,errors }">
                                        <b-form-group :label="$t('university')">
                                            <university-selectbox :public="true" v-model="form[i].university_id"
                                                                  :disabled="isBauStudent || user.payment_status==='E' || user.university_id!==null"
                                                                  @input="handleSetValue('university_id',$event)"
                                                                  :validate-error="errors[0]"
                                            />
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col sm="12" md="6" lg="6">
                                    <ValidationProvider name="student_status" rules="required" v-slot="{valid, errors}">
                                        <b-form-group :label="$t('student_status')">
                                            <multi-selectbox
                                                v-model="form[i].student_status"
                                                @input="handleSetValue('student_status',$event)"
                                                :multiple="false"
                                                :disabled="isBauStudent || user.payment_status==='E' || user.student_status!==null"
                                                :options="studentStatusOptions"
                                                :validate-error="errors[0]"></multi-selectbox>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col sm="12" md="6" lg="6">
                                    <ValidationProvider name="faculty_name" rules="required" v-slot="{valid, errors}">
                                        <b-form-group :label="$t('faculty_name')">
                                            <b-form-input size="sm" :readonly="isBauStudent || user.payment_status==='E' || user.faculty!==null"  :state="errors[0] ? false : (valid ? true : null)"
                                                          v-model="form[i].faculty" class="rounded-lg"></b-form-input>
                                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col sm="12" md="6" lg="6">
                                    <ValidationProvider name="program_name" rules="required" v-slot="{valid, errors}">
                                        <b-form-group :label="$t('program_name')">
                                            <b-form-input size="sm"  :readonly="isBauStudent || user.payment_status==='E' || user.program!==null"   :state="errors[0] ? false : (valid ? true : null)"
                                                          v-model="form[i].program" class="rounded-lg"></b-form-input>
                                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>

                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col sm="12" md="6" lg="6">
                                    <ValidationProvider name="gender" rules="required" v-slot="{valid, errors}">
                                        <b-form-group :label="$t('gender')">
                                            <b-form-input size="sm"  readonly   :state="errors[0] ? false : (valid ? true : null)"
                                                          v-model="form[i].gender" class="rounded-lg"></b-form-input>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col sm="12" md="6" lg="6">
                                    <ValidationProvider name="application_type"  rules="required" v-slot="{ valid,errors }">
                                        <b-form-group :label="$t('application_type')">
                                            <ParameterSelectbox v-model="form[i].application_type" @input="handleSetValue('application_type',$event)" code="toles_application_types"  :disabled="user.payment_status==='E'" :public="true" :validate-error="errors[0]"/>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col sm="12" md="6" lg="6">
                                    <ValidationProvider name="application_detail"  rules="required" v-slot="{ valid,errors }">
                                        <b-form-group :label="$t('course_code_option')+ '/'+$t('exam_name')">
                                            <ParameterSelectbox v-model="form[i].application_detail" @input="handleSetValue('application_detail',$event)"  :disabled="user.payment_status==='E'" code="toles_application_details"  :public="true" :validate-error="errors[0]"/>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col sm="12" md="6" lg="6">
                                    <ValidationProvider name="amount" v-slot="{ valid,errors }">
                                        <b-form-group :label="$t('amount')">
                                            <div class="label-as-input">
                                                {{currencyFormat(form[i].amount,form[i].currency??'TRY') }}
                                            </div>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col cols="12" class="d-flex gap-2">
                                    <ProcessingButton :label="$t('save')" v-if="user.payment_status==='H'" :processing="loading" :disabled="loading" @click="saveAndContinue(i)"/>
                                    <ProcessingButton :label="$t('make_payment')" v-if="user.payment_status==='H' &&  user.application_type && user.application_detail"  :disabled="invalid" @click="openPaymentModal"/>
                                </b-col>
                                <b-col cols="12">
                                </b-col>
                            </b-row>
                        </ValidationObserver>
                    </b-card>
                </b-collapse>
            </div>
        </div>
        <div v-else>
            <Loading/>
        </div>
        <CommonModal ref="paymentModal" size="md" :onHideOnlyX="true" @bHideModalHeaderClose="clear">
            <template v-slot:CommonModalContent>
                <CreditCartPaymentForm :payment-html="paymentHtml" v-if="formProcess==='payment'" @payment-success="payment($event)" :amount="Number(form[activeFormIndex].amount)" :currency="form[activeFormIndex].currency"/>
            </template>
        </CommonModal>
    </div>

</template>
<script>
import ProcessingButton from "@/components/elements/ProcessingButton.vue";
import TolesApplicationServices from "@/services/TolesApplicationServices";
import CreditCartPaymentForm from "@/components/elements/CreditCartPaymentForm.vue";

export default {
    name: "ApplicationForm",
    components: {ProcessingButton,CreditCartPaymentForm},
    data(){
        return {
            user:{},
            cloneForm:{
                currency:null,
                amount:0,
                university_id:null,
                student_status:null,
                faculty:null,
                program:null,
                application_type:null,
                application_detail:null,
            },
            paymentStatus:null,
            formProcess:null,
            selectedForm:null,
            sessionTimeout: null,
            successPaymentValue:false,
            TIMEOUT_DURATION: 30* 60 * 1000,
            form :{
                currency:null,
                amount:0,
                university_id:null,
                student_status:null,
                faculty:null,
                program:null,
                application_type:null,
                application_detail:null,
            },
            activeFormIndex:0,
            timer:null,
            loading:false,
            paymentHtml:null,
            studentStatusOptions:[
                {
                    text:this.$t('continue'),
                    value:"101"
                },
                {
                    text:this.$t('graduate'),
                    value:"102"
                }
            ]
        }
    },
    mounted() {
        if (!localStorage.getItem('sessionExpiryTime')) {
            this.setNewExpiryTime();
        }
        this.startSessionTimer();
    },
    beforeDestroy() {
        this.clearSessionTimer();
    },
    computed:{
        pin(){
            const hasPin =localStorage.getItem('pin')
            if (hasPin){
                return JSON.parse(localStorage.getItem('pin'))
            }
            return null
        },
        isBauStudent(){
            return [3817].includes(this.user.university_id)
        }
    },
    watch:{
        'cloneForm.university_id'(newValue,oldValue){
            if (newValue!==oldValue){
                this.checkForm()
            }
        },
        'cloneForm.application_type'(newValue,oldValue){
            if (newValue !==oldValue){
                this.checkForm()

            }
        },
        'cloneForm.student_status' (newValue,oldValue){
            if (newValue!==oldValue){
                this.checkForm()
            }
        },
        'cloneForm.application_detail' (newValue,oldValue){
            if (newValue!==oldValue){
                this.checkForm()
            }
        },
    },
    created() {
        this.user= localStorage.getItem('toles_application_user')?JSON.parse(localStorage.getItem('toles_application_user')):null
        if (this.user){
            this.handleSetForm()
            this.setSelectedForm()
        }
    },
    methods:{
        setNewExpiryTime() {
            const expiryTime = Date.now() + this.TIMEOUT_DURATION;
            localStorage.setItem('sessionExpiryTime', expiryTime);
        },
        startSessionTimer() {
            this.clearSessionTimer();
            const expiryTime = parseInt(localStorage.getItem('sessionExpiryTime'));
            const remainingTime = expiryTime - Date.now();
            if (remainingTime <= 0) {
                return this.handleTimeout();
            }
            this.sessionTimeout = setTimeout(() => {
                this.handleTimeout();
            }, remainingTime);
        },
        clearSessionTimer() {
            if (this.sessionTimeout) {
                clearTimeout(this.sessionTimeout);
                this.sessionTimeout = null;
            }
        },
        handleTimeout() {
            localStorage.removeItem('sessionExpiryTime');
            this.$store.dispatch('TolesApplicationStore/logout');
            this.$router.push('/toles/application/login').catch(()=>{});
            this.$toast.warning(this.$t('your_session_has_expired'))
        },
        clear(){
            this.paymentHtml=''
            this.formProcess=null
            this.checkPaymentStatus()
            this.$refs.paymentModal.$refs.commonModal.hide()
        },
        async payment(cartInformation){
            try {
                const form ={
                    national_id: this.user[0].national_id,
                    pin: this.pin,
                    card_number: cartInformation.card_number,
                    expiry_year: cartInformation.expiry_year,
                    expiry_month: cartInformation.expiry_month,
                    cvv: cartInformation.cvv,
                    card_holder_name: cartInformation.card_holder_name,
                }
                const res =await TolesApplicationServices.payment(form)
                this.paymentHtml=res.data
                this.openPaymentModal()
            }catch (err){
                this.showErrors(err,null)
            }
        },
        async saveAndContinue(index){
            const observer = this.$refs[`applicationForm-${index}`];
            if (observer && observer[0]) {
                const isValid = await observer[0].validate();
                if (!isValid) return;
            }
            try {
                this.loading=true
                this.selectedForm.pin=this.pin
                this.selectedForm.national_id=this.user[0]?.national_id
                let res;
                const user =this.user[0]
                if(this.selectedForm?.new_application && user.application_detail===null && user.application_type===null)
                    res = await TolesApplicationServices.addApplication(this.selectedForm)
                else{
                    res = await TolesApplicationServices.updateApplication(this.selectedForm)
                }
                this.user=res.data.data
                this.$store.dispatch('TolesApplicationStore/setTolesApplicationUser',res.data.data)
                this.$toast.success(this.$t('proccess_success'))
            }catch (err){
                this.showErrors(err,observer[0])
            }finally {
                this.loading=false
            }
        },
        checkForm(){
            if (!this.selectedForm)return;
            if (this.selectedForm.student_status && this.selectedForm.application_type && this.selectedForm.university_id && this.selectedForm.application_detail){
                if (this.timer)clearTimeout(this.timer)
                this.timer=setTimeout(()=>{
                    this.calculateAmount()
                },500)
            }
        },
        handleSetValue(key,value){
            this.cloneForm[key]=value
        },
        async calculateAmount(){
            if (this.selectedForm.payment_status==='E' && this.selectedForm.amount){
                this.form.amount=Number(this.selectedForm.amount)
                return
            }
            this.loading=true
            const formData ={
                application_type:this.selectedForm.application_type,
                university_id:this.selectedForm.university_id,
                student_status:this.selectedForm.student_status,
                application_detail:this.selectedForm.application_detail
            }
            try {
                const res =await TolesApplicationServices.calculateAmount(formData)
                const amount =res.data.data.amount
                const currency=res.data.data.currency
                const index=this.form.findIndex((item)=>item.payment_status==='H')
                this.activeFormIndex=index
                this.form[index].amount=amount ? Number(amount):0
                this.form[index].currency=currency
            }catch (err){
                this.showErrors(err)
            }finally {
                this.loading=false
            }
        },
        openPaymentModal(){
            this.formProcess='payment'
            this.$refs.paymentModal.$refs.commonModal.show()
        },
        async checkPaymentStatus(){
             try {
                 const form = {
                     national_id:this.user[0].national_id,
                     pin:this.pin
                 }
                 const res =await TolesApplicationServices.login(form)
                 const data =res.data.data
                 this.user=data
                 this.handleSetForm()
                 this.$store.dispatch('TolesApplicationStore/setTolesApplicationUser',data)
                 this.successPaymentValue=true
             }catch (err){
                 this.showErrors(err)
             }
        },
        newApplication(){
            const newApplicationButtonControl=this.user.every((item)=>item.payment_status==='E')
            if (!newApplicationButtonControl){
                this.$toast.warning('Tamamlanmamış Başvurunuz Var');
                return
            }
            const newApplication={
                university_id:this.user[0].university_id,
                student_status:this.user[0].student_status,
                national_id:this.user[0].national_id,
                payment_status:'H',
                faculty:this.user[0].faculty,
                program:this.user[0].program,
                gender:this.user[0].gender,
                payment_date:null,
                application_type:null,
                amount: null,
                currency:null,
                application_detail:null,
                new_application:true
            }
            this.user.unshift(newApplication)
            const newUser=this.user[0]
            this.form.unshift({
                university_id:newUser.university_id,
                student_status:newUser.student_status,
                payment_status:newUser.payment_status,
                faculty:newUser.faculty,
                program:newUser.program,
                gender:this.user[0].gender,
                payment_date:null,
                application_type:null,
                amount: null,
                currency:null,
                application_detail:null,
                new_application:true
            })
            this.setSelectedForm()
        },
        handleSetForm(){
            this.form=this.user.map((item)=>{
                return {
                    university_id:item.university_id,
                    student_status:item.student_status,
                    payment_status:item.payment_status,
                    faculty:item.faculty,
                    program:item.program,
                    gender:item.gender,
                    national_id:item.national_id,
                    pin:item.pin,
                    payment_date: item.payment_date,
                    application_type:item.application_type,
                    amount: item.amount??0,
                    currency:item.currency,
                    application_detail:item.application_detail,
                }
            })
        },
        setSelectedForm(){
            this.selectedForm=this.form.find((item)=>item.payment_status==='H')
        }
    }
}
</script>

<style scoped>

.form-control:disabled, .form-control[readonly] {
    background-color: #ffffff;
    pointer-events: none;
    opacity: 0.6;

}

</style>
